/* =========================================================
   Dynamic Diesels — Tune payback calculator (dd-tune-payback)

   ENGINES: per-engine performance data.
     years  = [first, last] model year
     scr    = first model year with a DEF/SCR system (null = none)
     stock  = typical real-world mpg, prefilled for the customer
     gain   = average highway fuel economy gain from the tune
     verified:false shows a "Preliminary data" badge until shop
     test results replace the placeholder gain.

   Tune price and product link are NOT here. They come from the
   product picked per engine in the theme editor (section
   settings), so prices always match the store. Engines with no
   product picked are hidden. Fuel prices are section settings too.
   ========================================================= */
(function () {
  var ENGINES = [
    { id: "ps73", makes: ["Ford"],               label: "7.3L Power Stroke",         years: [1994, 2003], scr: null, stock: 15, gain: 0.08, verified: false },
    { id: "ps60", makes: ["Ford"],               label: "6.0L Power Stroke",         years: [2003, 2007], scr: null, stock: 15, gain: 0.08, verified: false },
    { id: "ps64", makes: ["Ford"],               label: "6.4L Power Stroke",         years: [2008, 2010], scr: null, stock: 14, gain: 0.08, verified: false },
    { id: "ps67", makes: ["Ford"],               label: "6.7L Power Stroke",         years: [2011, 2026], scr: 2011, stock: 16, gain: 0.08, verified: false },
    { id: "ps30", makes: ["Ford"],               label: "3.0L Power Stroke (F-150)", years: [2018, 2021], scr: 2018, stock: 22, gain: 0.08, verified: false },
    { id: "lb7",  makes: ["Chevrolet", "GMC"],   label: "6.6L Duramax LB7",          years: [2001, 2004], scr: null, stock: 15, gain: 0.08, verified: false },
    { id: "lly",  makes: ["Chevrolet", "GMC"],   label: "6.6L Duramax LLY",          years: [2004, 2005], scr: null, stock: 15, gain: 0.08, verified: false },
    { id: "lbz",  makes: ["Chevrolet", "GMC"],   label: "6.6L Duramax LBZ",          years: [2006, 2007], scr: null, stock: 16, gain: 0.08, verified: false },
    { id: "lmm",  makes: ["Chevrolet", "GMC"],   label: "6.6L Duramax LMM",          years: [2007, 2010], scr: null, stock: 15, gain: 0.08, verified: false },
    { id: "lml",  makes: ["Chevrolet", "GMC"],   label: "6.6L Duramax LML",          years: [2011, 2016], scr: 2011, stock: 16, gain: 0.08, verified: false },
    { id: "l5p",  makes: ["Chevrolet", "GMC"],   label: "6.6L Duramax L5P",          years: [2017, 2026], scr: 2017, stock: 16, gain: 0.08, verified: false },
    { id: "lwn",  makes: ["Chevrolet", "GMC"],   label: "2.8L Duramax LWN",          years: [2016, 2022], scr: 2016, stock: 24, gain: 0.08, verified: false },
    { id: "lm2",  makes: ["Chevrolet", "GMC"],   label: "3.0L Duramax LM2",          years: [2020, 2022], scr: 2020, stock: 24, gain: 0.08, verified: false },
    { id: "lz0",  makes: ["Chevrolet", "GMC"],   label: "3.0L Duramax LZ0",          years: [2023, 2026], scr: 2023, stock: 24, gain: 0.08, verified: false },
    { id: "c59",  makes: ["Ram / Dodge"],        label: "5.9L Cummins",              years: [1994, 2007], scr: null, stock: 17, gain: 0.08, verified: false },
    { id: "c67",  makes: ["Ram / Dodge"],        label: "6.7L Cummins",              years: [2007, 2026], scr: 2013, stock: 17, gain: 0.08, verified: false },
    { id: "eco",  makes: ["Ram / Dodge", "Jeep"],label: "3.0L EcoDiesel",            years: [2014, 2023], scr: 2014, stock: 24, gain: 0.08, verified: false },
    { id: "c50",  makes: ["Nissan"],             label: "5.0L Cummins (Titan XD)",   years: [2016, 2019], scr: 2016, stock: 17, gain: 0.08, verified: false }
  ];
  var MIX = [
    { id: "hwy", label: "Highway", factor: 1.0 },
    { id: "mix", label: "Mixed",   factor: 0.85 },
    { id: "tow", label: "Towing",  factor: 0.6 }
  ];
  var DEF_RATIO = 0.025;

  function init(root) {
    if (root.dataset.tpcReady) return;
    root.dataset.tpcReady = "1";

    var dataEl = root.querySelector("[data-tpc-data]");
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var products = data.products || {};
    var engines = ENGINES.filter(function (e) { return products[e.id]; }).map(function (e) {
      var p = products[e.id];
      return Object.assign({}, e, { price: +p.price, url: p.url, product: p.title });
    });
    var regions = ((data.fuel && data.fuel.regions) || []).filter(function (r) { return isFinite(parseFloat(r.price)); });
    if (!engines.length || !regions.length) return;

    var q = function (k) { return root.querySelector("[data-tpc-" + k + "]"); };
    var el = {};
    ["year","make","engine","kitline","kitprice","truckhint","truck-legend","driving","fuel","mix","economy","distance",
     "region","pricesrc","fuelprice","defprice","deffield","years","yearsout","hero","herolead","herobig","herosub",
     "sfuel","sdef","svol","netk","netv","chart","cta","math","defratio","sticky","stv","stk","stcta"].forEach(function (k) { el[k] = q(k); });

    var state = { mix: "mix" };
    var CUR = data.currency || "USD", LOC = "en-US";
    var fallbackUrl = data.fallbackUrl || "/collections/all";

    function money(v, dp) { return new Intl.NumberFormat(LOC, { style: "currency", currency: CUR, maximumFractionDigits: dp || 0, minimumFractionDigits: dp || 0 }).format(v); }
    function num(v, dp) { return new Intl.NumberFormat(LOC, { maximumFractionDigits: dp || 0 }).format(v); }
    function val(node) { var n = parseFloat(node.value); return isFinite(n) ? n : 0; }
    function opt(sel, value, text) { var o = document.createElement("option"); o.value = value; o.textContent = text; sel.appendChild(o); }
    function reset(sel, text) { sel.innerHTML = ""; opt(sel, "", text); }
    function fits(e, y) { return y >= e.years[0] && y <= e.years[1]; }
    function engine() { var id = el.engine.value; return engines.filter(function (e) { return e.id === id; })[0] || null; }
    function hasDef(e, y) { return !!(e && e.scr && y >= e.scr); }
    function mixObj() { return MIX.filter(function (m) { return m.id === state.mix; })[0]; }

    // ---- Truck selector: year -> make -> engine ----
    var minY = Math.min.apply(null, engines.map(function (e) { return e.years[0]; }));
    var maxY = Math.max.apply(null, engines.map(function (e) { return e.years[1]; }));
    for (var y = maxY; y >= minY; y--) opt(el.year, y, y);

    el.year.addEventListener("change", function () {
      var yr = +el.year.value;
      reset(el.make, "Make"); reset(el.engine, "Engine");
      el.engine.disabled = true;
      if (!yr) { el.make.disabled = true; return truckChanged(); }
      var makes = [];
      engines.forEach(function (e) { if (fits(e, yr)) e.makes.forEach(function (m) { if (makes.indexOf(m) < 0) makes.push(m); }); });
      makes.sort().forEach(function (m) { opt(el.make, m, m); });
      el.make.disabled = !makes.length;
      truckChanged();
    });
    el.make.addEventListener("change", function () {
      var yr = +el.year.value, mk = el.make.value;
      reset(el.engine, "Engine");
      if (!mk) { el.engine.disabled = true; return truckChanged(); }
      var list = engines.filter(function (e) { return fits(e, yr) && e.makes.indexOf(mk) >= 0; });
      list.forEach(function (e) { opt(el.engine, e.id, e.label); });
      el.engine.disabled = false;
      if (list.length === 1) el.engine.value = list[0].id;
      truckChanged();
    });
    el.engine.addEventListener("change", truckChanged);

    function truckChanged() {
      var e = engine(), yr = +el.year.value;
      var ready = !!(e && yr);
      el.driving.disabled = !ready;
      el.fuel.disabled = !ready;
      el.kitline.hidden = !ready;
      if (ready) {
        el.kitprice.textContent = money(e.price);
        el.economy.value = e.stock;
        el.deffield.style.display = hasDef(e, yr) ? "" : "none";
        el.truckhint.textContent = hasDef(e, yr) ? "Your truck uses DEF, so we include DEF savings." : "Your truck has no DEF system, so savings are diesel only.";
      } else {
        el.truckhint.textContent = "We only show engines we carry tunes for.";
      }
      calc();
    }

    // ---- Driving mix ----
    MIX.forEach(function (m) {
      var b = document.createElement("button"); b.type = "button"; b.dataset.v = m.id; b.textContent = m.label;
      b.addEventListener("click", function () { state.mix = m.id; syncSeg(); calc(); });
      el.mix.appendChild(b);
    });
    function syncSeg() { Array.prototype.forEach.call(el.mix.querySelectorAll("button"), function (b) { b.setAttribute("aria-pressed", b.dataset.v === state.mix ? "true" : "false"); }); }

    // ---- Regions ----
    regions.forEach(function (r) { opt(el.region, r.id, r.label); });
    function applyRegion() {
      var r = regions.filter(function (x) { return x.id === el.region.value; })[0] || regions[0];
      el.fuelprice.value = parseFloat(r.price).toFixed(3);
      el.pricesrc.textContent = data.fuel.source ? "Source: " + data.fuel.source + (data.fuel.asOf ? ", " + data.fuel.asOf : "") + "." : "";
      calc();
    }
    el.region.addEventListener("change", applyRegion);

    // ---- Model ----
    function model() {
      var e = engine(), yr = +el.year.value;
      if (!e || !yr) return null;
      var m = mixObj();
      var gain = e.gain * m.factor;
      var econ = val(el.economy), dist = val(el.distance), fuel = val(el.fuelprice);
      var scr = hasDef(e, yr);
      var def = scr ? val(el.defprice) : 0;
      var econAfter = econ * (1 + gain);
      var volSaved = econ > 0 ? Math.max(0, dist / econ - dist / econAfter) : 0;
      var defSaved = scr ? volSaved * DEF_RATIO : 0;
      var fuelSave = volSaved * fuel, defSave = defSaved * def;
      var annual = fuelSave + defSave, monthly = annual / 12;
      return { e: e, yr: yr, m: m, gain: gain, econ: econ, econAfter: econAfter, dist: dist, fuel: fuel, def: def, kit: e.price,
               volSaved: volSaved, defSaved: defSaved, fuelSave: fuelSave, defSave: defSave, annual: annual, monthly: monthly,
               paybackMonths: monthly > 0 ? e.price / monthly : Infinity,
               paybackDist: annual > 0 ? dist * (e.price / annual) : Infinity,
               scr: scr };
    }

    function setBig(text, unit) {
      el.herobig.textContent = text;
      if (unit) { var s = document.createElement("small"); s.textContent = unit; el.herobig.appendChild(s); }
    }

    function calc() {
      var years = parseInt(el.years.value, 10);
      el.yearsout.textContent = years + (years === 1 ? " year" : " years");
      var r = model(), hero = el.hero;
      var url = r ? r.e.url : fallbackUrl;
      el.cta.href = url; el.stcta.href = url;
      el.cta.textContent = r ? "Shop the tune for your truck" : "Shop tunes";

      if (!r) {
        hero.classList.add("is-empty");
        el.herolead.textContent = "Start with your truck";
        setBig("Select year, make, and engine");
        el.herosub.textContent = "We'll price the tune for your exact truck and show your payback.";
        ["sfuel","sdef","svol","netv","stv","stk","math","netk"].forEach(function (k) { el[k].textContent = ""; });
        el.chart.innerHTML = "";
        var pb = root.querySelector(".dd-tpc__badge"); if (pb) pb.remove();
        el.sticky.classList.remove("is-shown");
        return;
      }

      if (!isFinite(r.paybackMonths)) {
        hero.classList.add("is-empty");
        el.herolead.textContent = "Not enough to estimate yet";
        setBig("Check your numbers");
        el.herosub.textContent = "Enter your current fuel economy and how far you drive each year.";
      } else {
        hero.classList.remove("is-empty");
        var mo = r.paybackMonths;
        el.herolead.textContent = "Pays for itself in";
        if (mo < 1) setBig("Under 1", "month");
        else if (mo < 24) setBig(String(Math.ceil(mo)), "months");
        else setBig((mo / 12).toFixed(1), "years");
        el.herosub.textContent = "About " + num(Math.round(r.paybackDist / 100) * 100) + " miles on your " + r.yr + " " + r.e.label +
          ", going from " + num(r.econ, 1) + " to " + num(r.econAfter, 1) + " mpg.";
      }

      el.sfuel.textContent = money(r.fuelSave);
      el.sdef.textContent = r.scr ? money(r.defSave) : "No DEF";
      el.svol.textContent = num(r.volSaved) + " gal";

      var net = r.annual * years - r.kit;
      el.netk.textContent = (net >= 0 ? "Ahead after " : "Still short after ") + years + (years === 1 ? " year" : " years");
      el.netv.textContent = (net >= 0 ? "+" : "") + money(net);
      el.netv.className = "dd-tpc__netv" + (net >= 0 ? " is-pos" : "");

      el.stv.textContent = isFinite(r.paybackMonths) ? (r.paybackMonths < 24 ? Math.max(1, Math.ceil(r.paybackMonths)) + " mo payback" : (r.paybackMonths / 12).toFixed(1) + " yr payback") : "Estimate pending";
      el.stk.textContent = money(r.annual) + " saved per year";

      var existing = root.querySelector(".dd-tpc__badge");
      if (!r.e.verified && !existing) { var b = document.createElement("span"); b.className = "dd-tpc__badge"; b.textContent = "Preliminary data"; el["truck-legend"].appendChild(b); }
      else if (r.e.verified && existing) existing.remove();

      var lines = [
        "Gain for " + r.e.label + ", " + r.m.label.toLowerCase() + ": " + (r.e.gain * 100).toFixed(0) + "% x " + r.m.factor + " = " + (r.gain * 100).toFixed(1) + "%",
        "Fuel economy: " + num(r.econ, 1) + " to " + num(r.econAfter, 2) + " mpg",
        "Diesel saved: " + num(r.volSaved, 1) + " gal x " + money(r.fuel, 3) + " = " + money(r.fuelSave) + "/yr"
      ];
      if (r.scr) lines.push("DEF saved: " + num(r.defSaved, 1) + " gal x " + money(r.def, 2) + " = " + money(r.defSave) + "/yr");
      lines.push("Payback: " + money(r.kit) + " / " + money(r.monthly, 2) + " per month = " + (isFinite(r.paybackMonths) ? r.paybackMonths.toFixed(1) : "n/a") + " months");
      el.math.innerHTML = "";
      lines.forEach(function (t) { var d = document.createElement("div"); d.textContent = t; el.math.appendChild(d); });

      drawChart(r, years);
      updateSticky();
    }

    function drawChart(r, years) {
      var W = 560, H = 230, L = 62, R = 16, T = 14, B = 34, months = years * 12;
      var total = r.monthly * months, maxY = Math.max(r.kit * 1.15, total * 1.05, 1);
      var x = function (m) { return L + (W - L - R) * (m / months); };
      var y = function (v) { return T + (H - T - B) * (1 - v / maxY); };
      var line = "#3f7d00", kit = "#8a8a86", grid = "#e3e3e0", tick = "#6c6c73";
      var s = '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg" font-family="Archivo, system-ui, sans-serif">';
      for (var i = 0; i <= 3; i++) {
        var v = maxY * i / 3, yy = y(v);
        s += '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + yy + '" y2="' + yy + '" stroke="' + grid + '" stroke-width="1"/>';
        s += '<text x="' + (L - 8) + '" y="' + (yy + 4) + '" text-anchor="end" font-size="12" fill="' + tick + '">' + money(v) + '</text>';
      }
      for (var yr = 0; yr <= years; yr++) s += '<text x="' + x(yr * 12) + '" y="' + (H - 10) + '" text-anchor="middle" font-size="12" fill="' + tick + '">' + (yr === 0 ? "Now" : "Yr " + yr) + '</text>';
      s += '<line x1="' + L + '" x2="' + (W - R) + '" y1="' + y(r.kit) + '" y2="' + y(r.kit) + '" stroke="' + kit + '" stroke-width="2" stroke-dasharray="5 5"/>';
      s += '<path d="M' + x(0) + ' ' + y(0) + ' L' + x(months) + ' ' + y(total) + ' L' + x(months) + ' ' + y(0) + ' Z" fill="#8fce2b" opacity=".18"/>';
      s += '<line x1="' + x(0) + '" y1="' + y(0) + '" x2="' + x(months) + '" y2="' + y(total) + '" stroke="' + line + '" stroke-width="3" stroke-linecap="round"/>';
      if (isFinite(r.paybackMonths) && r.paybackMonths <= months) {
        var bx = x(r.paybackMonths), by = y(r.kit), anchor = bx > W - 120 ? "end" : "start", dx = anchor === "end" ? -10 : 10;
        s += '<line x1="' + bx + '" x2="' + bx + '" y1="' + by + '" y2="' + y(0) + '" stroke="' + line + '" stroke-width="1" opacity=".5"/>';
        s += '<circle cx="' + bx + '" cy="' + by + '" r="6" fill="' + line + '" stroke="#fff" stroke-width="2"/>';
        s += '<text x="' + (bx + dx) + '" y="' + (by - 12) + '" text-anchor="' + anchor + '" font-size="13" font-weight="700" fill="#0a0a0b">Paid off</text>';
      }
      el.chart.innerHTML = s + '</svg>';
    }

    [el.economy, el.distance, el.fuelprice, el.defprice, el.years].forEach(function (n) { n.addEventListener("input", calc); });

    // Mobile summary bar: shown while the results are still below the fold.
    // Re-checked on every calc too, since the observer only fires when the
    // hero crosses the viewport edge, not when a truck gets picked.
    function updateSticky() {
      var rect = el.hero.getBoundingClientRect();
      el.sticky.classList.toggle("is-shown", rect.top > window.innerHeight && !!model());
    }
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(updateSticky, { threshold: 0 }).observe(el.hero);
    }

    // ---- WebMCP: let AI agents run the calculator (progressive enhancement) ----
    try {
      var mc = navigator.modelContext;
      if (mc) {
        var allMakes = [];
        engines.forEach(function (e) { e.makes.forEach(function (m) { if (allMakes.indexOf(m) < 0) allMakes.push(m); }); });
        var tool = {
          name: "estimate_tune_payback",
          description: "Estimate yearly diesel and DEF savings and payback time for a Dynamic Diesels tune on a specific U.S. truck.",
          inputSchema: { type: "object", required: ["year", "make", "engine"], properties: {
            year: { type: "integer" },
            make: { type: "string", enum: allMakes.sort() },
            engine: { type: "string", enum: engines.map(function (e) { return e.id; }) },
            driving: { type: "string", enum: MIX.map(function (m) { return m.id; }) },
            mpg: { type: "number" }, milesPerYear: { type: "number" },
            region: { type: "string", enum: regions.map(function (r) { return r.id; }) }
          } },
          execute: function (a) {
            a = a || {};
            el.year.value = a.year; el.year.dispatchEvent(new Event("change"));
            el.make.value = a.make; el.make.dispatchEvent(new Event("change"));
            el.engine.value = a.engine; truckChanged();
            if (a.driving) { state.mix = a.driving; syncSeg(); }
            if (a.mpg) el.economy.value = a.mpg;
            if (a.milesPerYear) el.distance.value = a.milesPerYear;
            if (a.region) { el.region.value = a.region; applyRegion(); }
            calc();
            var r = model();
            return { content: [{ type: "text", text: JSON.stringify(r ? {
              tune: r.e.product, tunePrice: r.kit, currency: CUR, annualFuelSavings: Math.round(r.fuelSave), annualDefSavings: Math.round(r.defSave),
              paybackMonths: isFinite(r.paybackMonths) ? +r.paybackMonths.toFixed(1) : null, preliminaryData: !r.e.verified
            } : { error: "No tune listed for that year, make, and engine." }) }] };
          }
        };
        if (typeof mc.registerTool === "function") mc.registerTool(tool);
        else if (typeof mc.provideContext === "function") mc.provideContext({ tools: [tool] });
      }
    } catch (err) {}

    // ---- Init ----
    syncSeg();
    el.defratio.textContent = (DEF_RATIO * 100).toFixed(1) + "%";
    var dp = parseFloat(data.defPrice);
    el.defprice.value = (isFinite(dp) ? dp : 3.75).toFixed(2);
    applyRegion();
    truckChanged();
  }

  function boot() { document.querySelectorAll("[data-tpc]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
